import React, { Component, createRef } from 'react';
import { render } from 'react-dom';
import HierarchyFieldBox from './HierarchyFieldBox.jsx';

class HierarchyLevelsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: [1],
    };
    this.levelRefs = {};
    HierarchyDefinitions.forEach((i) => {
      this.levelRefs[i.level] = createRef();
    });
  }

  componentDidMount() {
    this.levelRefs[1].current.loadData(null);
  }

  openLevel(node, level) {
    level = level.level + 1;
    if (level > HierarchyDefinitions.length) {
      return;
    }
    const opened = _.uniq([...this.state.opened, level]).filter(
      (i) => i <= level,
    );
    this.setState({ opened: opened });
    this.levelRefs[level].current.loadData(node);
  }

  deletedLevel(node) {
    const index = this.state.opened.indexOf(node.depth_level + 2);
    const next = this.levelRefs[index + 1]
      ? this.levelRefs[index + 1].current
      : undefined;

    if (
      index >= 0 &&
      typeof next !== 'undefined' &&
      next.state.parent.id === node.id
    ) {
      const opened = [...this.state.opened];
      opened.splice(index, Number.MAX_VALUE);
      this.setState({ opened: opened });
    }
  }

  render() {
    let containerStyle = { width: this.state.opened.length * 220 };

    return (
      <div
        className='HierarchyLevelsView'
        style={containerStyle}
      >
        {' '}
        {HierarchyDefinitions.sort((a, b) => a.level - b.level).map((i) => {
          return (
            <HierarchyFieldBox
              key={i.id}
              ref={this.levelRefs[i.level]}
              data={i}
              deletedLevel={this.deletedLevel.bind(this)}
              opened={this.state.opened}
              openLevel={this.openLevel.bind(this)}
            />
          );
        })}{' '}
      </div>
    );
  }
}

module.exports = (elm) => render(<HierarchyLevelsView />, elm);
